import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=4b1bbb72&scoped=true"
import script from "./customer.vue?vue&type=script&name=customer&lang=js"
export * from "./customer.vue?vue&type=script&name=customer&lang=js"
import style0 from "./customer.vue?vue&type=style&index=0&id=4b1bbb72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1bbb72",
  null
  
)

export default component.exports